import { URL } from "./utils";

/**
 * Panel auth token'ına store/baseQuery tarafından erişim.
 * AuthProvider mount'ta setGetter ile bağlar; 401 → refresh sonrası setNewToken ile token güncellenir.
 */
let holder = null;

export function setAuthTokenGetter(getter) {
  holder = getter;
}

export function getAuthTokenHolder() {
  return holder;
}

/**
 * Aynı anda uçuşta olan refresh isteği. Paralel çağrılar yeni istek açmak yerine
 * bu promise'i paylaşır — böylece N tane eşzamanlı 401, N değil TEK refresh üretir.
 */
let inFlightRefresh = null;

/**
 * Son BAŞARILI refresh sonucu. Eşzamanlı olmayan ama birbirine yakın 401'ler
 * (paralel istekler farklı ms'lerde döner) tazeyken tekrar refresh tetiklemesin.
 */
let lastRefresh = { at: 0, result: null };
const REFRESH_COOLDOWN_MS = 3000;

async function doRefreshRequest() {
  const base = URL.url.replace(/\/$/, "");
  try {
    const res = await fetch(`${base}/api/users/refresh`, {
      method: "POST",
      credentials: "include",
    });
    const data = await res.json();
    if (res.ok && data?.status === "success" && data?.token) {
      return { token: data.token, user: data.data?.user || null };
    }
  } catch (_) {
    // ignore
  }
  return null;
}

/**
 * Cookie ile refresh endpoint'ini çağırır; başarılıysa { token, user } döner, değilse null.
 *
 * Deduplike edilmiştir: hem AuthProvider'ın proaktif yenilemesi hem
 * baseQueryWithReauth'un 401 sonrası yenilemesi bu tek fonksiyondan geçer.
 * Uçuşta bir istek varsa ona katılır; 3sn içinde başarılı bir refresh olmuşsa
 * onun sonucunu döndürür. Aksi halde panelde açılan her sayfa, paralel
 * isteklerinin sayısı kadar /api/users/refresh çağırıyordu (sunucuda 429 riski).
 */
export function refreshAccessToken() {
  if (inFlightRefresh) return inFlightRefresh;

  if (lastRefresh.result && Date.now() - lastRefresh.at < REFRESH_COOLDOWN_MS) {
    return Promise.resolve(lastRefresh.result);
  }

  inFlightRefresh = doRefreshRequest()
    .then((result) => {
      if (result) lastRefresh = { at: Date.now(), result };
      return result;
    })
    .finally(() => {
      inFlightRefresh = null;
    });

  return inFlightRefresh;
}

/** Logout/oturum sonlandığında önbelleği temizler (eski token'ın sızmaması için). */
export function resetRefreshCache() {
  inFlightRefresh = null;
  lastRefresh = { at: 0, result: null };
}
